const reducer = (state: WtrState) => ({
  ...state,
  slotsDisabled: true,
});

export default reducer;
